module.exports = __webpack_public_path__ + "fonts/Montserrat-ExtraBold.9bc77c3.ttf";